import "nodelist-foreach-polyfill";

const triggers = document.querySelectorAll<HTMLElement>(".js-ga-event");
triggers.forEach((ele) => {
  ele.addEventListener("click", () => {
    gtag("event", "conversion", {
      send_to: "AW-768579922/8pCQCPuEuf4BENKyvu4C",
    });
  });
});
